import PluginDecorator from './PluginDecorator';
import SkyClickPlayer from "../../components/custom/SkyClickPlayer";
import {PlaylistEventType, default as PlaylistPluginDecorator} from "./PlaylistPluginDecorator";
import {PlayerComponentHookType} from "../../components/wrappers/PlayerComponentWrapper";
import Dom from "../../utils/custom/Dom";

// load plugin
require('../../../customized_vendor/videojs-resolution-switcher-0.4.2/lib/videojs-resolution-switcher.js');
require('../../../customized_vendor/videojs-resolution-switcher-0.4.2/lib/videojs-resolution-switcher.css');

export type ResolutionSwitcherEventTypes =
    'RESOLUTION_CHANGED'; // after resolution has changed


export default class ResolutionSwitcherPluginDecorator extends PluginDecorator {

    static readonly PLUGIN_NAME: string = 'resolution-switcher';

    static bootingStaticApi() {
        super.bootingStaticApi();
        this.hookManagerInstance.add<PlayerComponentHookType>('BEFORE_SETUP', (videoEl: Element, options: any) => {
            return this.processOptions(options);
        });
    }

    static processOptions(options: any) {

        // get option section for plugin (create new object, when don't exists)
        let pluginOptions = options.plugins.videoJsResolutionSwitcher =
            options.plugins.videoJsResolutionSwitcher || {};

        // define on options, that the plugin will be initialized → workaround
        // pluginOptions.dynamicLabel = true;

        // check qualities
        options.playlist.forEach(function (playlistItem: any) {
            let defaultQualityDefined = false;

            playlistItem.qualities.forEach(function (quality: any) {
                if (quality.default) {
                    defaultQualityDefined = true;
                }
                // quality.type = quality.type || 'video/webm';
            });

            // set default quality, when no is selected
            if (!defaultQualityDefined) {
                playlistItem.qualities[0].default = true;
            }

        });

        return options;
    }

    protected get systemEventAliases(): Object {
        return {
            'resolutionchange': 'RESOLUTION_CHANGED'
        }
    }

    protected playlistPluginDecorator: PlaylistPluginDecorator;

    // remember the chosen quality
    protected selectedResolution:String = '';

    public bootingExecution(){
        this.playlistPluginDecorator = this.skyClickPlayer.pluginManager.getPluginDecorator<PlaylistPluginDecorator>(PlaylistPluginDecorator.PLUGIN_NAME);

        // add item change listener
        this.eventManager.addListener<PlaylistEventType>('PLAYLIST_ITEM_CHANGE', this.onPlaylistChange.bind(this));
        this.eventManager.addListener<ResolutionSwitcherEventTypes>('RESOLUTION_CHANGED', this.backupSelectedResolution.bind(this));

        // run item change lister at startup
        this.onPlaylistChange(null, this.playlistPluginDecorator.getCurrentItem());
    }

    protected onPlaylistChange(event:any, currentItem:any) {
        let qualities = currentItem.qualities;

        // update only src with qualities, when qualities exists
        if (qualities.length > 1) {
            // init quality switcher
            this.skyClickPlayer.updateSrc(qualities);
        }else{
            // remove quality switcher, when one exists
            this.skyClickPlayer.controlBar.resolutionSwitcher && this.skyClickPlayer.controlBar.resolutionSwitcher.dispose();
        }

        let isResolutionSelected = false;
        // choose correct resolution
        qualities.forEach((quality: any) => {
            if (this.selectedResolution == quality.label || // remembered resolution
                (quality.default && !this.selectedResolution)) { // default selection
                this.changeResolution(quality.label);
                isResolutionSelected = true;
            }
        });
        // if there is no default or selectedResolution - choose first one
        if (!isResolutionSelected) {
            this.changeResolution(qualities[0].label);
        }
    }

    public getCurrentResolution() {
        return this.skyClickPlayer.currentResolution();
    }

    /**
     * Count of qualities
     */
    public getCount(){
        const currentItem = this.playlistPluginDecorator.getCurrentItem();
        return currentItem && currentItem.qualities.length;
    }

    public changeResolution(newResolutionLabel: string) {
        this.skyClickPlayer.currentResolution(newResolutionLabel);
    }

    public hideControlElement(){
        Dom.addElClass(this.skyClickPlayer.controlBar.resolutionSwitcher.el(),'vjs-hide');
    }

    public showControlElement(){
        Dom.removeElClass(this.skyClickPlayer.controlBar.resolutionSwitcher.el(),'vjs-hide');
    }

    private backupSelectedResolution(){
        // backup current quality, when more than one quality exists
        if(this.getCount() > 1) {
            this.selectedResolution = this.getCurrentResolution().label;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/plugins/decorators/ResolutionSwitcherPluginDecorator.ts